import React from "react";
import { useSelector } from "react-redux";

import { ApplicationState } from "../store";

const LoggedOut: React.FC = props => {
    const user = useSelector((state: ApplicationState) => state.userAuth.user);
    return user ? <></> : <>{props.children}</>;
};

LoggedOut.displayName = "LoggedOut";

export default LoggedOut;
